import { render, staticRenderFns } from "./zodiac-card.vue?vue&type=template&id=5dcd741a"
import script from "./zodiac-card.vue?vue&type=script&lang=js"
export * from "./zodiac-card.vue?vue&type=script&lang=js"
import style0 from "./zodiac-card.vue?vue&type=style&index=0&id=5dcd741a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports